import { motion } from 'framer-motion';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export const DataProtectionAddendum = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="data-protection-page">
      <Navbar />
      <main className="pt-24 pb-20">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="label-text text-[#6B7280] block mb-4">Legal</span>
            <h1 className="heading-lg text-3xl md:text-4xl lg:text-5xl text-[#1E3A5F] mb-8">
              Data Protection Addendum
            </h1>
            <p className="text-[#6B7280] mb-8">Last updated: January 2026</p>
            
            <div className="prose prose-lg max-w-4xl text-[#4B5563]">
              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">1. Introduction</h2>
                <p className="mb-4">
                  This Data Protection Addendum ("DPA") forms part of the Agreement between Easysend and the Client 
                  for the provision of payment services. This DPA sets out the terms that apply when Personal Data is 
                  processed by Easysend under or in connection with the Agreement.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">2. Definitions</h2>
                <p className="mb-4">
                  <strong>"Personal Data"</strong> means any information relating to an identified or identifiable natural person.
                </p>
                <p className="mb-4">
                  <strong>"Processing"</strong> means any operation performed on Personal Data, including collection, storage, 
                  use, disclosure, or deletion.
                </p>
                <p className="mb-4">
                  <strong>"Data Controller"</strong> means the entity that determines the purposes and means of processing Personal Data.
                </p>
                <p className="mb-4">
                  <strong>"Data Processor"</strong> means the entity that processes Personal Data on behalf of the Data Controller.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">3. Scope of Processing</h2>
                <p className="mb-4">
                  Easysend will process Personal Data only to the extent necessary for the performance of the services 
                  and in accordance with the Client's documented instructions, unless required to do so by applicable law.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">4. Security Measures</h2>
                <p className="mb-4">
                  Easysend implements appropriate technical and organisational measures to ensure a level of security 
                  appropriate to the risk, including:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Encryption of Personal Data in transit and at rest</li>
                  <li>Access controls and authentication mechanisms</li>
                  <li>Regular security assessments and penetration testing</li>
                  <li>Employee training on data protection and security</li>
                  <li>Incident response and breach notification procedures</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">5. Sub-processors</h2>
                <p className="mb-4">
                  Easysend may engage sub-processors to assist in providing the services. Easysend will ensure that 
                  sub-processors are bound by data protection obligations no less protective than those in this DPA.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">6. Data Subject Rights</h2>
                <p className="mb-4">
                  Easysend will assist the Client in responding to requests from data subjects exercising their rights 
                  under applicable data protection laws, including rights of access, rectification, erasure, and portability.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">7. International Transfers</h2>
                <p className="mb-4">
                  Where Personal Data is transferred outside the European Economic Area, Easysend will ensure appropriate 
                  safeguards are in place, such as Standard Contractual Clauses or equivalent mechanisms.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">8. Contact</h2>
                <p className="mb-4">
                  For questions regarding this Data Protection Addendum, please contact us at{' '}
                  <a href="mailto:privacy@easysendservices.com" className="text-[#4FB3DF] hover:underline">
                    privacy@easysendservices.com
                  </a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
